<span class="FcAgEditor__ImageWrapper" [ngClass]="{'FcAgEditor__Resizer--Active': selected}" [style.width]="outerWidth">
  <span class="FcAgEditor__ResizeHandle" *ngIf="selected">
    <span class="FcAgEditor__ResizeHandle--TL" (mousedown)="startResizing($event, 'left')"></span>
    <span class="FcAgEditor__ResizeHandle--TR" (mousedown)="startResizing($event, 'right')"></span>
    <span class="FcAgEditor__ResizeHandle--BL" (mousedown)="startResizing($event, 'left')"></span>
    <span class="FcAgEditor__ResizeHandle--BR" (mousedown)="startResizing($event, 'right')"></span>
  </span>
  <img [src]="src" [alt]="alt" [title]="title" #imgEl/>
</span>
